<ul *ngIf='show && data.length > 0' [style.top]='top' [style.left]='left'>
  <li *ngFor='let item of data' (click)='addValue(item)' class="{{lastSelected === item ? 'selected' : ''}} {{lastSelected.name && lastSelected !== item ? 'unselected' : ''}} {{item.noResults ? 'no-results' : ''}}">
    <i class='fa fa-circle-thin select-icon'></i>
    <h3 class='item-name'>{{ item.name }}</h3>
    <span [innerHTML]="item.detail" class='item-detail'></span>
  </li>
</ul>
